import {
  Issuer,
} from "@/model/Issuer";

import {
  ApiResponse,
  defaultFetch,
  httpMethod,
} from "@/scripts/Common/api";

import {
  getToken,
} from "@/scripts/Common";
import {
  IssuerDto,
} from "@/model/IssuerDto";
import {
  IssuerCard,
} from "@/components/issuers/scripts/issuerCards";
import {
  CreateIssuerResult,
  FetchIssuersParam
} from "./types";

const fetchIssuers = async (args: FetchIssuersParam = {}, abortSignal? : AbortSignal): Promise<ApiResponse<Issuer[]>> => {

  const {
    response,
    error,
    paginationCount,
    paginationLimit,
    paginationPage,
    totalItemCount
  } = await defaultFetch({
    apiName: 'issuers',
    bearer: getToken(),
    options: {
      query: {
        ...args,
        pageNumber: typeof args?.pageNumber === 'number' ? args.pageNumber - 1 : undefined, // reduce by 1 to make it 0 based
      },
      abortSignal
    }
  });

  const issuers: Issuer[] = [];
  if(response){
    (response as IssuerDto[]).forEach(dto => issuers.push(new Issuer(dto)))
  }

  return {
    response: issuers,
    error,
    paginationCount,
    paginationLimit,
    paginationPage,
    totalItemCount
  }
}

const fetchIssuer = async (id: number): Promise<ApiResponse<Issuer>> => {

  // validate arguments
  if (id <= 0) {
    return {
      error: 'Id must be greater than 0.'
    }
  }

  const {
    response,
    error,
  } = await defaultFetch({
    apiName: 'issuersWithParams',
    bearer: getToken(),
    options: {
      routeParams: {
        param: id.toString()
      }
    }
  });

  return {
    response: new Issuer(response as IssuerDto),
    error,
  }
}

const createOrUpdateIssuer = async (issuer: Issuer, method: httpMethod.PUT | httpMethod.POST)
  : Promise<ApiResponse<CreateIssuerResult>> => await defaultFetch({
  apiName: 'issuers',
  options: {
    method
  },
  body: JSON.stringify(issuer.GetModel()),
  bearer: getToken()
});

const updateIssuerState = async (issuer: Issuer, param: string)
  : Promise<ApiResponse<number>> => await defaultFetch({
  apiName: 'issuersWithParams',
  options: {
    method: httpMethod.PUT,
    routeParams: {
      param
    }
  },
  body: JSON.stringify(issuer.GetModel()),
  bearer: getToken()
});

const fetchIssuerCards = async (issuerId: number)  : Promise<ApiResponse<IssuerCard[]>>  =>
  await defaultFetch({
    apiName: 'getIssuerCardList',
    bearer: getToken(),
    options: {
      query: {
        issuerId: issuerId,
        pageNumber: 0,
        pageSize: 1,
      }
    }
  })

const deleteIssuer = async (issuerId: number) => {
  const {
    error,
  } = await defaultFetch({
    apiName: 'issuers',
    options: {
      method: httpMethod.DELETE,
      query: {
        issuerId
      }
    },
    bearer: getToken()
  });

  return {
    error,
  };
}

export {
  fetchIssuers,
  fetchIssuer,
  createOrUpdateIssuer,
  updateIssuerState,
  fetchIssuerCards,
  deleteIssuer
}
